import {useEffect, useState, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {gaConfig} from '@stencil/hotels-config';
import Filter from '../Filter/Filter';
import {PrimaryLink} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import FoodForkIcon from '@stencil/icons/src/FoodFork/FoodForkIcon';
import HappyPayAtHotelNewIcon from '@stencil/icons/src/HappyPayAtHotelNewIcon/HappyPayAtHotelNewIcon';
import * as S from './FiltersGroup.styles';

const {DetailsGAClickEventActions} = gaConfig;

const FiltersGroupItem = ({
  index,
  data,
  setFilters,
  currentFilters = [],
  appliedFiltersList = [],
  setFiltersOnApply,
}: {
  index;
  data;
  setFilters;
  currentFilters;
  appliedFiltersList;
  setFiltersOnApply;
}) => {
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);

  const [showList, setShowList] = useState(false);
  const [isClearAllButtonClicked, setIsClearAllButtonClicked] = useState(false);

  const pushInGA = (filtersNameList = []) => {
    setTimeout(() => {
      let totalRoomCount = document.querySelectorAll('#room-options-name') || [];
      let filterNameStr = filtersNameList.map(item => item?.name).join('|');
      dispatch(
        detailsPagePushGaThunk({
          eventAction: DetailsGAClickEventActions.roomSelection.filterClick,
          eventLabel: 'top|' + totalRoomCount?.length + '|' + filterNameStr,
        }),
      );
    }, 200);
  };

  const applyButtonClick = () => {
    //check if appliedFilters contain filterlistinfo and then erase those which are not present in currentiflters
    /**
     * Case 1
     * APFL = ['PAH','BNPL','FB']  <--> CFL = ['PAH']
     * NA = ['PAH','BNPL','FB','PAH']  <---->  DFL = ['PAH','BNPL','PN']
     * FFL = ['PAH','FB']
     * ----------------Next Case----------------
     * Case 2
     * APFL = ['FB']  <--> CFL = ['PAH','BNPL']
     * NA = ['PAH','BNPL','FB']  <---->  DFL = ['PAH','BNPL','PN']
     * FFL =
     *  ----------------Next Case----------------
     * Case 3
     * APFL = ['FB','PAH']  <--> CFL = ['PN','BNPL']
     * NA = ['BNPL','FB','PN']  <---->  DFL = ['PAH','BNPL','PN']
     * FFL =
     *
     * */
    let copyOfAppliedFiltersList = JSON.parse(JSON.stringify(appliedFiltersList));
    let filterListNameArr = data?.ratePlanFilterList.map(item => item?.title),
      currentCheckedNameFiltersArr = currentFilters.map(item => item?.title);
    for (let i = 0; i < appliedFiltersList?.length; i++) {
      let filterName = appliedFiltersList[i]?.title;
      if (
        filterListNameArr.indexOf(filterName) > -1 &&
        currentCheckedNameFiltersArr.indexOf(filterName) == -1
      ) {
        copyOfAppliedFiltersList[i] = -1;
      }
    }
    copyOfAppliedFiltersList = copyOfAppliedFiltersList.filter(item => item !== -1);
    copyOfAppliedFiltersList = [...copyOfAppliedFiltersList, ...currentFilters];
    let newArr = copyOfAppliedFiltersList.filter(
      (v, i, a) => a.findIndex(t => t.title === v.title) === i,
    );
    setTimeout(() => {
      setFiltersOnApply(newArr);
      setShowList(false);
      pushInGA(newArr);
    }, 0);
  };

  const onClearAllButtonClick = () => {
    setIsClearAllButtonClicked(true);
    let copyOfCurrentFiltersList = [];

    let filterListNameArr = data?.ratePlanFilterList.map(item => item?.title);
    for (let i = 0; i < appliedFiltersList.length; i++) {
      let filterName = appliedFiltersList[i]?.title;
      if (filterListNameArr.indexOf(filterName) == -1) {
        copyOfCurrentFiltersList.push(appliedFiltersList[i]);
      }
    }
    let newArr = copyOfCurrentFiltersList.filter(
      (v, i, a) => a.findIndex(t => t.title === v.title) === i,
    );

    setFilters(newArr);
  };

  const handleClickOutside = event => {
    if (showList) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowList(false);
      }
    }
    return;
  };

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    if (showList) {
      /**
       * Need to check when list is open then if filters is not present in copyCurrentFilterList Array
       * then remove that from copyCurrentFilterList show that it is not checked
       */

      setFilters(appliedFiltersList);
    }

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showList]);

  const getIcon = (name, isActive) => {
    switch (name) {
      case 'Add Meals':
        return <FoodForkIcon margin={'0 6px 0 2px'} fill={!isActive ? '#2274E0' : '#fff'} />;
      case 'Pay Options':
        return (
          <HappyPayAtHotelNewIcon margin={'0 6px 0 2px'} fill={!isActive ? '#2274E0' : '#fff'} />
        );
      default:
        return <></>;
    }
  };

  const checkIfActiveAndCount = () => {
    let status = false,
      count = 0;
    let appliedFiltersNameArr = appliedFiltersList?.map(item => item?.title);
    let newArr = data?.ratePlanFilterList?.filter(
      item => appliedFiltersNameArr.indexOf(item?.title) > -1,
    );
    if (newArr?.length > 0) {
      (status = true), (count = newArr?.length);
    }
    return {status, count};
  };

  return (
    <li
      key={index}
      className={`${checkIfActiveAndCount()?.status ? 'active' : ''}`}
      onClick={() => {
        setShowList(!showList);
      }}
      ref={wrapperRef}
    >
      {getIcon(data?.text, checkIfActiveAndCount()?.status)}
      <span className={`${showList ? 'showList' : ''}`}>
        {data?.text}
        {checkIfActiveAndCount()?.count > 0 ? ' (' + checkIfActiveAndCount()?.count + ')' : ''}
      </span>
      {showList && (
        <S.FilterDropdown>
          <S.FilterDropdownTop>
            <Filter
              setFilters={setFilters}
              currentFilters={currentFilters}
              roomFilterList={data?.ratePlanFilterList}
              customOuterWrapperPadding={'7px 2px'}
              isGroupFilters={true}
              setIsClearAllButtonClicked={setIsClearAllButtonClicked}
            />
          </S.FilterDropdownTop>
          <S.FilterDropdownBottom>
            <PrimaryLink
              onClick={e => {
                e.stopPropagation();
                onClearAllButtonClick();
              }}
            >
              Clear All
            </PrimaryLink>
            <S.FilterApplyBtn
              onClick={e => {
                e.stopPropagation();
                applyButtonClick();
              }}
            >
              Apply
            </S.FilterApplyBtn>
          </S.FilterDropdownBottom>
        </S.FilterDropdown>
      )}
    </li>
  );
};

export default FiltersGroupItem;
